import { gql } from '@apollo/client'

export const MUTATION_REMOVE_TAGS_FOR_RENTALS = gql`
  mutation mutationRemoveTagsForRentals($input: RemoveTagsForRentalsInput!) {
    removeTagsForRentals(input: $input)
  }
`
